






















import { Component, Vue, Prop } from "vue-property-decorator";
import TreeView from "../components/TreeView.vue";
@Component({
  components: {
    TreeView
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name === "search_category") {
        vm.$store.state.backRoute = from;
      }
    });
  }
})
export default class Tree extends Vue {
  @Prop() private tree!: string;
  @Prop() private decisionId!: string;
  @Prop() private decisionName!: string;
  @Prop() private tab!: string;

  private drawer = false;
  get back() {
    return this.$store.state.backRoute || {};
  }
}
